export default __webpack_public_path__ + "static/media/ic_fav_120_gradient.4f13f9f4.svg";